<template>
  <div class="index" v-if="data.style" :style="'position: relative;background-image:url('+oss+data.style.backgroundImage+');background-color:'+data.style.backgroundColor">
    <div class="join_btn" :style="'background-image:url('+oss+data.style.btnBackgroundImage+')'"></div>
  </div>
</template>

<script>
import config from "@/config";
export default {
  props: { data: Object },
  setup() {
    const oss = config.oss[process.env.VUE_APP_type];
    return {
      oss,
    };
  },
};
</script>

<style lang="less" scoped>
.index {
  width: 337px;
  height: 667px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .top_btn {
    position: absolute;
    right: 12px;
    top: 21px;
    > div {
      width:80px;
      height: 24px;
      background: rgba(250, 250, 250, 0.6);
      border-radius: 12px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #af1817;
      text-align: center;
      line-height: 24px;
      margin-bottom: 5px;
    }
  }
  .dm {
    position: absolute;
    bottom: 150px;
    width: 211px;
    height: 30px;
    border-radius: 0px 15px 15px 0px;
    background-color: rgba(250, 250, 250, 0.6);
    display: flex;
    align-items: center;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #af1817;
    padding-left: 14px;
    img {
      width: 24px;
      height: 24px;
    }
  }
  .join_btn {
    position: absolute;
    bottom: 121px;
    width:185px;
    height: 48px;
    left: 50%;
    transform: translateX(-50%);
    background-size: cover;
  }
}
</style>